export const LS_KEY_FOR_MIGRATION_MODAL_DISMISSED =
  'AFL-modalDismissed-migration2026'

export const LS_KEY_FOR_PRE_MIGRATION_MODAL_DISMISSED =
  'AFL-modalDismissed-preMigration2026'
